import React from 'react';
import Service from '../../apis/service-manager';
import Urls from '../../apis/url';
import { Route, Redirect } from 'react-router-dom';
import SessionCache from './session-cache';
import Path from './routes-path';
import Loading from '../common/loading/loading';
import IndexedDBHelper from '../../offline/apis/indexDBManager';
import HomeComponent from '../home-component/home-component';
import { Constants } from '../../constants/constants';
import JigyasaAssessments from '../jigyasa-admin/jigyasa-assessments';
import IndexedDBHelperV2 from '../../offline/apis/indexDBManager-v2';
import CommonUtils from '../../utility/common-utilities';
import LayoutShared from '../common/layout-shared/layout-shared';

const dbHelper = new IndexedDBHelperV2(Constants.DB_NAME, Constants.DB_VERSION, Constants.STORE_CONFIG);



let commonPath = [Path.DASHBOARD, Path.UPDATE_PASSWORD, Path.ONBOARD]

let allowedPath = {
    ADMIN: Path.ADMIN,
    USERS: Path.USERS,
    CLASSES: Path.CLASSES,
    HOMEWORK: Path.HOMEWORK,
    TEST: Path.TEST,
    PROFILE: Path.PROFILE,
    STUDENTS: Path.STUDENTS,
    SCHOOLS: Path.SCHOOLS,
    ASSESSMENT: Path.ASSESSMENT,
    QUESTION_BANK: Path.QUESTION_BANK,
    LEARNING_RESOURCES: Path.LEARNING_RESOURCES
}
export default class AuthenticateRoute extends React.Component {

    state = {
        isLoading: true,
        isOnline: CommonUtils.isOnline()
    }

    constructor(props) {
        super(props)
        // this.updateOnlineStatus = this.updateOnlineStatus.bind(this);
        // this.updateOnlineStatus()
        this.layoutShared = LayoutShared.getLayout()
    }

    componentDidMount() {
        this.isAuthenticated();
        // window.addEventListener('online', this.updateOnlineStatus);
        // window.addEventListener('offline', this.updateOnlineStatus);
    }


    componentWillUnmount() {
        // Remove event listeners when the component unmounts
        // window.removeEventListener('online', this.updateOnlineStatus);
        // window.removeEventListener('offline', this.updateOnlineStatus);
    }

    updateOnlineStatus() {
        // Update the state with the current online status
        // console.log(navigator.onLine)

        // if (!CommonUtils.isOnline()) {
        //     this.setState({ isLoading: true })
        //     setTimeout(() => {
        //         this.setState({ isOnline: CommonUtils.isOnline() }, () => {
        //             this.isAuthenticated()
        //             this.setState({ isLoading: true })
        //         });
        //     }, 10000);
        // }
    }

    isAuthenticated() {

        let userInfo = SessionCache.getUser()

        console.log('inside authenticate route .........', userInfo)

        // SessionCache.setUser(null);

        if ((!CommonUtils.isOnline()) && userInfo) {
            dbHelper.getAllFromIndex(Constants.STAFF_STORE, 'email', userInfo.email.trim()).then((data) => {
                console.log('Retrieved data:...', data);
                SessionCache.setUser(data[0]);
                this.setState({
                    ...data,
                    isLoading: false
                });
            }).catch(err => {
                console.log(err)
            })
            return;
        }
        // else if (!CommonUtils.isOnline()) {
        //     dbHelper.getAllData(Constants.STAFF_STORE).then((data) => {
        //         console.log('Retrieved data:', data);
        //         SessionCache.setUser(data[0]);
        //         this.setState({
        //             ...data[0],
        //             isLoading: false
        //         });

        //     }).catch(err => {
        //         console.log(err)
        //     })
        //     return;
        // }



        if (SessionCache.isAuthenticated() == null) {
            console.log(CommonUtils.isOnline(), '..................')
            dbHelper.getData(Constants.COOKIE_STORE, 'session').then(resCookie => {
                let payload = {}
                if (resCookie && resCookie.value) {
                    payload = {
                        token: resCookie.value
                    }
                }
                Service.getData(Urls.IS_LOGGEDIN, payload, (err, res) => {
                    if (res) {
                        // console.log(res.data)
                        dbHelper.updateData(Constants.STAFF_STORE, res.data).then((id) => {
                            // console.log('Data added with id:', id);
                        }).catch(err => {
                            console.log(err)
                        })
                        SessionCache.setUser(res.data);
                        this.setState({
                            ...res.data,
                            isLoading: false
                        });
                    } else {
                        // console.log()
                        this.setState({ isLoading: false })
                    }
                });
            })
        }
        else {
            console.log('Null Authenticated')
            SessionCache.setUser(null);
            this.setState({
                isLoading: false
            });
        }
    }

    validateWithUserActions() {
        let pathName = window.location.pathname

        console.log(pathName)

        if (commonPath.indexOf(pathName) >= 0) {
            return (<Route {...this.props} component={this.props.component} />)
        }

        let userActions = SessionCache.getUserActions()

        console.log(userActions)

        for (let i = 0; i < userActions.length; i++) {

            let action = userActions[i]

            if (allowedPath[action.moduleName] === pathName) {
                return (<Route {...this.props} component={this.props.component} />)
            }

        }

        console.log('here')

        // return (<Route path={Path.LOGIN} component={HomeComponent} />)

        console.log(this.props)

        // if(!navigator.onLine) {
        //     return (<Route {...this.props} to = {Path.ASSING_ASSESSMENT} component={JigyasaAssessments} />)
        // }

        return (<Route {...this.props} to={Path.DASHBOARD} component={this.props.component} />)
    }

    render() {
        let isAuthenticated = SessionCache.isAuthenticated()
        let isVerified = SessionCache.isVerified()
        console.log(isAuthenticated, isVerified, this.props.path)
        return (
            <div>
                {this.state.isLoading && <Loading></Loading>}
                {!this.state.isLoading && isAuthenticated && this.props.path == Path.LOGIN && <Redirect to={Path.DASHBOARD} />}
                {!this.state.isLoading && isAuthenticated && isVerified && this.validateWithUserActions()}
                {!this.state.isLoading && !isAuthenticated && <Redirect to={Path.LOGIN} />}
            </div>
        );
    }

}